
import { Component, OnInit, ViewChild } from '@angular/core';
import { MatTableDataSource } from '@angular/material/table';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort, Sort } from '@angular/material/sort';
import { SelectionModel } from '@angular/cdk/collections';
import { MatDialog } from '@angular/material/dialog';
import { FirestoreService } from 'src/app/services/service.index';
import { FormControl, Validators } from '@angular/forms';
import Swal from 'sweetalert2';
import { ItemsformComponent } from '../itemsform/itemsform.component';
import { ItemeditComponent } from '../itemedit/itemedit.component';

@Component({
  selector: 'app-items',
  templateUrl: './items.component.html',
  styleUrls: ['./items.component.css']
})
export class ItemsComponent implements OnInit {

  user:any;

  companyId:any;

  driverId:any;

  urlImg:any = "../../../assets/img/images.jpeg";

  drivers = new FormControl('', [
    Validators.required,
    Validators.email,
  ]);

  //'id',
  displayedColumns: string[] = [ 'select', 'code', 'name', 'description', 'status', 'actions'];


  driversList: any = [];
  dataSource = new MatTableDataSource();

  @ViewChild(MatPaginator, {static: true}) paginator: MatPaginator;
  @ViewChild(MatSort, {static: true}) sort: MatSort;

  selection = new SelectionModel<any>(true, []);

  constructor(public dialog: MatDialog, private afs: FirestoreService) { }


  openDialogAdd(): void {
    const dialogRef = this.dialog.open(ItemsformComponent, {
      width: '600px',
      data: ''
    });

    dialogRef.afterClosed().subscribe(result => {
      console.log('The dialog was closed');
    });
  }


  openDialogEdit(cars: any): void {
    console.log(cars)

    const dialogRef = this.dialog.open(ItemeditComponent, {
      data: cars
    });

    /*dialogRef.afterClosed().subscribe(result => {
      console.log('The dialog was closed');
    });*/
  }


  /** Whether the number of selected elements matches the total number of rows. */
  isAllSelected() {
    const numSelected = this.selection.selected.length;
    const numRows = this.dataSource.data.length;
    return numSelected === numRows;
  }

  /** Selects all rows if they are not all selected; otherwise clear selection. */
  masterToggle() {
    this.isAllSelected() ?
        this.selection.clear() :
        this.dataSource.data.forEach(row => this.selection.select(row));
  }


applyFilter(event: Event) {
const filterValue = (event.target as HTMLInputElement).value;
this.dataSource.filter = filterValue.trim().toLowerCase();
}


sortData(sort: Sort) {
//const data = ELEMENT_DATA.slice();
if (!sort.active || sort.direction === '') {
  //this.sortedData = data;
  return;
}

}

ngOnInit(): void {

  this.user = this.afs.usersShow;




  this.afs.getAllItems(this.user.companyId).subscribe( items => {


       this.dataSource.data = items;


  });

}


deleteItem(item:any){

  Swal.fire({
    title: 'Are you sure?',
    text: "You won't be able to revert this!",
    icon: 'warning',
    showCancelButton: true,
    confirmButtonColor: '#3085d6',
    cancelButtonColor: '#d33',
    confirmButtonText: 'Yes, delete it!',
  }).then((result) => {
    if (result.value) {
           this.afs
             .deleteItem(this.user.companyId, item.id)
             .then((resp: any) => {
               Swal.fire('Good job!', 'Succesful!", "success', 'success');
             })
             .catch((error) => {
               console.log(error);
             });
    }
  });

}

getColorStatus(status){

if(status == 0){
    return '#e74c3c'
}else if(status ==1){
   return '#2980b9'
}else if(status == 2){
   return '#2ecc71'
}
}


statusCar(status){
if(status == 0){
    return "Inactive";
}else if(status == 1){
  return "Active";
}
}



getDriver(driverId){


  if(driverId=='' || driverId == null){
      return 'No Assigned';
  }else{

    let driverUs = this.driversList.filter( driver => driverId == driver.id);

    if(driverUs.length > 0){
      return driverUs[0].firstname+" "+driverUs[0].lastname;
    }

  }
}

getColorDriver(driver){
if(driver=='' || driver == null){
    return '#576574'
}else{
    return '#01a3a4'
}
}

selectDriver(cus){

  this.driverId = cus.value;
}

asignVehicleUser(){

//console.log(this.driverId);

let orders = this.selection.selected;

orders.forEach(element => {


  if(element.driverId  == '' || element.driverId  == null) {

  element.driverId = this.driverId;


  this.afs.updateVehicle(this.user.companyId, element.id, element).then(res => {


       Swal.fire('Good job!', 'Car assigned succesful', 'success');

       this.selection.clear();
       this.drivers.setValue("");


  }).catch(err => {

    Swal.fire('Oops...', 'Car has not been asigned! ' + err, 'error');

  });

}else{



    Swal.fire('Oops...', 'Car!!', 'error');


}

});

}

unsignedCar(car){

let orders = this.selection.selected;

console.log(orders.length);

if(orders.length > 0){

car.driverId = '';


this.afs.updateVehicle(this.user.companyId, car.id, car).then( cars => {

  Swal.fire('Good job!', 'Vehicle unassigned succesful!', 'success');

    this.selection.clear();
    this.drivers.setValue("");

}).catch(err => {

    console.log(err);

});
}else{


  Swal.fire('Oops...', 'Should select one order!!', 'error');

}


}

}
